require("fslightbox");

export const lightbox = () => {
    console.log('lightboxloaded');
    fsLightbox.props.type = "image";
}
